import { useQuery } from 'react-query';
import { getMerchantDocument } from 'services/documentService';
import type { DocumentId } from 'types/Document';

export default function useGetMerchantDocumentByScreen(
  screen: DocumentId['screen']
) {
  return useQuery(
    ['merchantDocuments', screen],
    (ctx) =>
      getMerchantDocument(screen, { page: 1, itemsPerPage: 30 }, ctx.signal),
    { staleTime: 1000 * 60 * 10 } // 10 minutes
  );
}
